import throttle from "lodash.throttle";
import * as React from "react";
import { MoreVertical16Regular } from "@fluentui/react-icons";
import { If } from "../../../../core/components/If";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import {
    hideModal,
    showModal,
    showYesNoPrompt
} from "../../../../redux/reducers/ModalReducer";
import {
    addDroppedFile,
    cleanDroppedFilesRepertoireState,
    setEditableFields, setProgressUploadFileRepertoireProccess
} from "../../../../redux/reducers/MembersPortalReducer";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import {
    EVENT_HANDLER_THROTTLE_TIME, LIVE_PERFORMANCE_PERFORMANCE_END_DATE_STATE_KEY, LIVE_PERFORMANCE_SPANS_TWO_DATES_STATE_KEY, SEARCH_VIEW_DRAFT_SET_LISTS
} from "../../../Consts";
import IMembersPortalComponentDataItem from "../../../../redux/types/IMembersPortalComponentDataItem";
import { IWorkState } from "../../../../redux/types/IWorkState";
import { DataSource } from "../../../../repertoire/types/DataSource";
import MultiStepForm, { Step } from "../../../components/multiStepForm/MultiStepForm";
import { IFileSystem } from "../../../../dataingestion/types/IFileSystem";
import { ITreeData } from "../../../../repertoire/types/ITreeData";
import { IComponentDataItem } from "../../../../core/types/IComponentDataItem";
import { IDistribution } from "../../../../repertoire/types/usageTypes/IDistribution";
import { ILookupInstance } from "../../../../lookup/types/ILookup";
import IDroppedFiles from "../../../../redux/types/IDroppedFiles";
import { CleanUploadFilesState, addFileToUpload, setInDropZone, setProgressUploadFileProccess, sortColumn, updatePagination } from "../../../../redux/reducers/DataIngestionReducer";
import { IStoragePathItemData } from "../../../../dataingestion/types/IStoragePathItemData";
import { IAttachedFile } from "../../../../redux/types/IAttachedFile";
// import { addDroppedFile, cleanDroppedFilesRepertoireState, setProgressUploadFileRepertoireProccess } from "../../../../redux/reducers/RepertoireReducer";
import { IPaginationDetail } from "../../../../redux/types/IPaginationDetail";
import { FormatFields } from "../../../../redux/types/FormatFields";
import { IDataActionToolbar } from "../../../types/IDataActionToolbar";
import { ILivePerformanceValidation } from "../../../types/ILivePerformanceValidation";
import LivePerformanceMaintenanceGeneralDataView from "../livePerformanceMaintenanceGeneralDataView/LivePerformanceMaintenanceGeneralDataView";
import LivePerformanceMaintenanceToolbar from "../livePerformanceMaintenanceToolbar/LivePerformanceMaintenanceToolbar";
import { IUsageGroupState, IUsageGroupStateKeys } from "../../../../redux/types/IUsageGroupState";
import { IUsageGroupSetListAdditionalStateKeys } from "../../../../repertoire/types/usageTypes/IUsageGroupSetListAdditional";
import { IUsageGroupVenueDetailsStateKeys } from "../../../../repertoire/types/usageTypes/IUsageGroupVenueDetails";
import LivePerformanceMultiStepForm from "../../../components/multiStepForm/LivePerformanceMultiStepForm";
import { UsageDetailsMapper } from "../../../../repertoire/services/usageServices/UsageDetailsMapper";
import { CONFIGURATION_PARAMETER_LIVE_PERFORMANCE_VALIDATION_OPTIONS, CONFIGURATION_PARAMETER_PORTAL_USAGE_TITLE_FORMAT, PORTAL_CONFIGURATION_GROUP, USAGE_MAINTENANCE_GROUP } from "../../../ConfigurationConsts";
import { SearchRequests } from "../../../../repertoire/services/SearchRequests";
import { adjustProgramDates, buildDisabledDate, formatDateToDisplay, getDatePart } from "../../../../util/tools";
import { ICustomerVenue } from "../../../../repertoire/types/ISetListVenue";
import InfoToggle from "../../../sharedComponents/button/InfoToggle";
import { IMembersPortalPathInfo } from "../../../types/IMembersPortalPathInfo";

export interface ILivePerformanceMaintenancePageProps {
    livePerformanceMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem;
    livePerformanceMaintenanceToolbarData?: IMembersPortalComponentDataItem;
    draftWorkMaintenanceSaveResultData?: IMembersPortalComponentDataItem;
    livePerformanceMaintenanceGridsViewData?: IMembersPortalComponentDataItem;
    dataGridTableData?: IRepertoireComponentDataItem;
    usage?: IUsageGroupState;
    activeTab: number;
    tabs: ITabReduxItem[];
    dataSource: DataSource;
    lookupValues?: ILookupDictionary;
    hideModal: typeof hideModal;
    showYesNoPrompt: typeof showYesNoPrompt;
    resetMessageBanner: () => void;
    addNewDraftLivePerformance: (lookupValues: ILookupDictionary, isNew?: boolean, livePerfromanceMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem) => void;
    updateLivePerformanceField?: (value: any, fieldName: IUsageGroupStateKeys, index?: number) => void;
    updateLivePerformanceSetListAdditionalField: (value: any, fieldName: IUsageGroupSetListAdditionalStateKeys, index?: number) => void;
    updateLivePerformanceVenueDetailsField: (value: any, fieldName: IUsageGroupVenueDetailsStateKeys, index?: number) => void;
    saveChanges: (usage: IUsageGroupState, livePerformanceMaintenanceGeneralDataViewData: IMembersPortalComponentDataItem, lookupValues: ILookupDictionary) => void;
    getDraftWorkDetails: (dataSource: string, draftWorksID: number, lookupValues: ILookupDictionary, draftWorkMaintenanceDataViewData: IMembersPortalComponentDataItem) => void;
    showModal: typeof showModal;
    loadMembersPortalFromPath: (pathInfo: IMembersPortalPathInfo, currentUserNameNumber: string, location: Location) => void;
    clearModalSearchResults: () => void;
    copyExistingDraftLivePerformance: (actionList: IDataActionToolbar[], userName: string, lookups: ILookupDictionary) => void;
    incrementTempID?: () => void;
    containerDetailsWindowComponentData: IComponentDataItem;
    distributions: IDistribution[];
    formats: ILookupInstance[];
    destinations: ILookupInstance[];
    selectedFileSystem: IFileSystem;
    droppedFiles: IDroppedFiles;
    setInDropZone: typeof setInDropZone;
    addFileToUpload: typeof addFileToUpload;
    isDropZone: boolean;
    setProgressUploadFileProccess: typeof setProgressUploadFileProccess;
    cleanUploadFilesState: typeof CleanUploadFilesState;
    storagePaths: IStoragePathItemData[];
    storagePathItemData: IComponentDataItem;
    refreshDirectory: (filesystem: IFileSystem, sources: ITreeData[]) => void;
    addRepertoireAttachmentToState: (attachedFile: IAttachedFile) => void;
    attachedFiles: IStoragePathItemData[];
    removeWorkAttachmentIfExists: (attachedFile: IAttachedFile, source: DataSource) => void;
    removeLivePerformanceAttachmentFromState: (attachedFile: IAttachedFile) => void;
    UsageAttachmentsDropped?: IDroppedFiles;
    addDroppedFileRepertoire?: typeof addDroppedFile;
    setProgressUploadFileRepertoire: typeof setProgressUploadFileRepertoireProccess;
    cleanDroppedFilesRepertoire: typeof cleanDroppedFilesRepertoireState;
    paginationDetails: IPaginationDetail[];
    updatePagination: typeof updatePagination;
    sortColumn: typeof sortColumn;
    getDataIngestionComponentData?: () => void;
    getFilesystems?: (isRepertoireModule?: boolean) => void;
    refreshWorkDetails: (dataSource: string, workID: number, lookups: ILookupDictionary, otherIndicatorsWorkFlagTypes: string[], activeTabItem: ITabReduxItem, readonlyIndicatorsWorkFlagTypes: string[], formats?: FormatFields[]) => void;
    stepsCurrent?: number;
    stepsSetCurrent?: (current: number) => void;
    currentUser: string;
    portalType: string;
    currentUserNameNumber: string;
    updatedScroll?: number;
    licenseVenues?: ICustomerVenue[];
    client?: string;
}


interface IILivePerformanceMaintenancePagePropsState {
    toolbarWidth: number;
    isBulkCheckboxActive?: boolean;
    loading: boolean;
    livePerformanceValidation: ILivePerformanceValidation;
    portalUsageTitleFormat: boolean;
    spansTwoDates: boolean;
    mainUsageEndDate?: string;
    dateRangeInitialized: boolean;
}

export class LivePerformanceMaintenancePage extends React.PureComponent<
    ILivePerformanceMaintenancePageProps,
    IILivePerformanceMaintenancePagePropsState
> {
    toolbarParentRef;
    constructor(props: ILivePerformanceMaintenancePageProps) {
        super(props);
        this.state = {
            toolbarWidth: null,
            isBulkCheckboxActive: false,
            loading: true,
            livePerformanceValidation: null as ILivePerformanceValidation | null,
            portalUsageTitleFormat: false,
            spansTwoDates: false,
            mainUsageEndDate: undefined,
            dateRangeInitialized: false
        };

        this.toolbarParentRef = React.createRef();
    }

    componentDidMount() {

        SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_LIVE_PERFORMANCE_VALIDATION_OPTIONS, USAGE_MAINTENANCE_GROUP)
            .then(validationRules => this.setState({ livePerformanceValidation: validationRules }));

        SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_PORTAL_USAGE_TITLE_FORMAT, PORTAL_CONFIGURATION_GROUP)
            .then(portalUsageTitleFormat => this.setState({ portalUsageTitleFormat: !!portalUsageTitleFormat }));

        const {
            getFilesystems,
            getDataIngestionComponentData,
            containerDetailsWindowComponentData } = this.props;
        if (!containerDetailsWindowComponentData || !containerDetailsWindowComponentData.fields || containerDetailsWindowComponentData.fields.length === 0) {
            getDataIngestionComponentData();
        }
        getFilesystems(true);
        CleanUploadFilesState();

        this.initializeDateRangeState();
    }

    componentDidUpdate(prevProps: Readonly<ILivePerformanceMaintenancePageProps>) {
        const { livePerformanceMaintenanceGeneralDataViewData, livePerformanceMaintenanceGridsViewData, containerDetailsWindowComponentData, usage } = this.props;

        if (livePerformanceMaintenanceGeneralDataViewData && livePerformanceMaintenanceGeneralDataViewData.fields && livePerformanceMaintenanceGeneralDataViewData.fields.length > 0
            && livePerformanceMaintenanceGridsViewData && livePerformanceMaintenanceGridsViewData.fields && livePerformanceMaintenanceGridsViewData.fields.length > 0
            && containerDetailsWindowComponentData && containerDetailsWindowComponentData.fields && containerDetailsWindowComponentData.fields.length > 0
            && !!this.state.livePerformanceValidation
            && this.state.loading) {
            this.setState({ loading: false });
        }
        const previousMainUsage = prevProps.usage?.usages?.[0];
        const currentMainUsage = usage?.usages?.[0];
        const usageBecameAvailable = !previousMainUsage && !!currentMainUsage;
        const usageChanged = prevProps.usage?.id !== usage?.id;
        const dateRangeChanged = previousMainUsage?.programStartDate?.value !== currentMainUsage?.programStartDate?.value || previousMainUsage?.programEndDate?.value !== currentMainUsage?.programEndDate?.value;
        if (currentMainUsage && (usageChanged || dateRangeChanged || (!this.state.dateRangeInitialized && usageBecameAvailable))) {
            this.initializeDateRangeState();
        }


        const previousTab = prevProps.tabs?.[prevProps.activeTab];
        const currentTab = this.props.tabs?.[this.props.activeTab];
        const saveSucceeded = !previousTab?.saveSuccessful && currentTab?.saveSuccessful;
        if (saveSucceeded && currentMainUsage) {
            const startDate = getDatePart(currentMainUsage?.usageDate?.value || currentMainUsage?.programStartDate?.value);

            const effectiveEndDate = this.state.spansTwoDates && this.state.mainUsageEndDate ? this.state.mainUsageEndDate : startDate;

            const spansTwoDates = !!startDate && !!effectiveEndDate && startDate !== effectiveEndDate;

            this.setState({spansTwoDates, mainUsageEndDate: spansTwoDates ? effectiveEndDate : undefined, dateRangeInitialized: true});
        }
    }

    buildLivePerformanceTitle = (draftLivePerformance: IUsageGroupState): string => {
        const usageDate = formatDateToDisplay(draftLivePerformance.usages[0]?.usageDate?.value);

        if (this.state.portalUsageTitleFormat) {
            return `${draftLivePerformance.fullPerformer} @ ${draftLivePerformance.location?.venue} (${usageDate})`;
        }

        return draftLivePerformance.matchingProducts != null && draftLivePerformance.matchingProducts.length > 0
            ? `${draftLivePerformance.matchingProducts[0].title[0]} (${usageDate})`
            : "";
    }

    confirmAndSubmit = () => {
        const { saveChanges, usage, livePerformanceMaintenanceGeneralDataViewData, lookupValues } = this.props;

        const draftLivePerformance = this.prepareUsageForSave(usage, this.state.spansTwoDates ? this.state.mainUsageEndDate : undefined);
        draftLivePerformance.approvalStatus = "Pending";
        saveChanges(draftLivePerformance, livePerformanceMaintenanceGeneralDataViewData, lookupValues); 
        this.setState({ isBulkCheckboxActive: false });
    }

    saveAsDraftLivePerformance = () => {
        const { saveChanges, usage, livePerformanceMaintenanceGeneralDataViewData, lookupValues } = this.props;
        const draftLivePerformance = this.prepareUsageForSave(usage, this.state.spansTwoDates ? this.state.mainUsageEndDate : undefined);
        saveChanges(draftLivePerformance, livePerformanceMaintenanceGeneralDataViewData, lookupValues);
        this.setState({ isBulkCheckboxActive: false });
    }

    undoChanges = () => {
        //const { dataSource, usage, undoDraftWorks, lookupValues } = this.props;
        //undoDraftWorks(dataSource, usage.id, lookupValues);
    }

    resetMessageBanner() {
        const { resetMessageBanner } = this.props;
        resetMessageBanner();
    }



    refreshWorkDetails() {
        const { tabs, activeTab, lookupValues, dataSource } = this.props;
        let currentTab = tabs[activeTab];
        this.props.refreshWorkDetails(
            dataSource,
            currentTab.workMaintenanceState.work.workID,
            lookupValues,
            tabs[activeTab].otherIndicatorWorkFlagTypes,
            currentTab,
            tabs[activeTab].readonlyIndicatorWorkFlagTypes
        )
    }

    initializeDateRangeState = () => {
        const mainUsage = this.props.usage?.usages?.[0];

        if (!mainUsage) {
            return;
        }

        const startDate = getDatePart(mainUsage.programStartDate?.value || mainUsage.usageDate?.value);

        const endDate = getDatePart(mainUsage.programEndDate?.value);

        const spansTwoDates = !!startDate && !!endDate && startDate !== endDate;

        this.setState({spansTwoDates, mainUsageEndDate: spansTwoDates ? endDate : undefined, dateRangeInitialized: true});
    };

    prepareUsageForSave = (usage: IUsageGroupState, mainUsageEndDate?: string): IUsageGroupState => {

        const preparedUsage: IUsageGroupState = JSON.parse(JSON.stringify(usage));

        const mainUsage = preparedUsage.usages?.[0];

        if (!mainUsage) {
            return preparedUsage;
        }

        const adjustedMainDates = adjustProgramDates(
            mainUsage.programStartDate.value,
            mainUsage.programEndDate.value,
            mainUsage.usageDate.value,
            mainUsageEndDate
        );

        if (adjustedMainDates) {
            mainUsage.programStartDate.value = adjustedMainDates.startDate.toISOString();
            mainUsage.programEndDate.value = adjustedMainDates.endDate.toISOString();
            mainUsage.usageDate.value = adjustedMainDates.startDate.toISOString();
        }

        preparedUsage.moreDates?.forEach(item => {
            const effectiveEndDate = item.spansTwoDates?.value && item.usageEndDate?.value ? item.usageEndDate.value : item.usageDate.value;

            const adjustedDates = adjustProgramDates(
                item.programStartDate.value,
                item.programEndDate.value,
                item.usageDate.value,
                effectiveEndDate
            );

            if (adjustedDates) {
                item.programStartDate.value = adjustedDates.startDate.toISOString();
                item.programEndDate.value = adjustedDates.endDate.toISOString();
                item.usageDate.value = adjustedDates.startDate.toISOString();
            }
        });
        preparedUsage.usages?.forEach(item => {
            item.weight.value = "1";
            item.usageCount.value = "1";
        });
        preparedUsage.productType = "SET LIST";
        preparedUsage.totalWeight = (1 + (preparedUsage.moreDates?.length ?? 0)).toString();
        preparedUsage.fullTitle = this.buildLivePerformanceTitle(preparedUsage);
        return preparedUsage;
    };

    onSpansTwoDatesChange = (spansTwoDates: boolean) => {
        const currentUsageDate = getDatePart(this.props.usage?.usages?.[0]?.usageDate?.value);

        this.setState({spansTwoDates, mainUsageEndDate: spansTwoDates ? this.state.mainUsageEndDate ?? currentUsageDate : undefined});

        this.props.updateLivePerformanceField?.(spansTwoDates, LIVE_PERFORMANCE_SPANS_TWO_DATES_STATE_KEY as IUsageGroupStateKeys);
    };

    onMainUsageEndDateChange = (mainUsageEndDate?: string) => {
        this.setState({
            mainUsageEndDate
        });

        this.props.updateLivePerformanceField?.(mainUsageEndDate, LIVE_PERFORMANCE_PERFORMANCE_END_DATE_STATE_KEY as IUsageGroupStateKeys);
    };

    render() {
        const { containerDetailsWindowComponentData, currentUserNameNumber } = this.props;
        let usage = this.props.usage ?? UsageDetailsMapper.createNewUsageState(this.props.lookupValues, null, parseInt(currentUserNameNumber), this.props.portalType);
        if (usage) {
            const {
                tabs,
                activeTab,
                livePerformanceMaintenanceGeneralDataViewData,
                livePerformanceMaintenanceToolbarData,
                draftWorkMaintenanceSaveResultData,
                livePerformanceMaintenanceGridsViewData,
                hideModal,
                showYesNoPrompt,
                addNewDraftLivePerformance,
                updateLivePerformanceField,
                lookupValues,
                dataGridTableData,
                showModal,
                copyExistingDraftLivePerformance,
                loadMembersPortalFromPath,
                incrementTempID,
                dataSource,
                stepsCurrent,
                stepsSetCurrent,
                currentUser,
                addFileToUpload,
                cleanUploadFilesState,
                destinations,
                distributions,
                droppedFiles,
                isDropZone,
                selectedFileSystem,
                setInDropZone,
                setProgressUploadFileProccess,
                sortColumn,
                storagePathItemData,
                attachedFiles,
                refreshDirectory,
                addRepertoireAttachmentToState,
                removeWorkAttachmentIfExists,
                removeLivePerformanceAttachmentFromState,
                addDroppedFileRepertoire,
                UsageAttachmentsDropped,
                cleanDroppedFilesRepertoire,
                setProgressUploadFileRepertoire,
                paginationDetails,
                updatePagination,
                refreshWorkDetails,
                getDataIngestionComponentData,
                licenseVenues
            } = this.props;

            const { fullPerformer, dateLoaded } = usage;

            const disabledDate = this.state.livePerformanceValidation ?
                buildDisabledDate(this.state.livePerformanceValidation.AllowFuturePerformances, this.state.livePerformanceValidation.PastPerformanceCutoff)
                : undefined;

            const infoToggleHeaderField = livePerformanceMaintenanceGeneralDataViewData.fields
                .find(x => x.name === 'infoToggleHeader');

            const infoToggleHtmlField = livePerformanceMaintenanceGeneralDataViewData.fields
                .find(x => x.name === 'infoToggleHTML');


            const renderInfoToggle = (
                <InfoToggle
                    headerTextItem={infoToggleHeaderField}
                    htmlTextItem={infoToggleHtmlField}
                    currentUserNameNumber={currentUserNameNumber}
                    lookupValues={lookupValues}
                    loadMembersPortalFromPath={loadMembersPortalFromPath}
                />
            )

        let isNewLivePerformance: boolean = this.props.usage?.id ? true : false;
            let { client } = this.props;
            const title = dateLoaded + "-" + fullPerformer;
            const changesMade = tabs[activeTab].changesMade || false;
            const isReadonly: boolean = tabs[activeTab].isReadonly ? tabs[activeTab].isReadonly : tabs[activeTab].saveSuccessful;

            let readOnlyDataGridTableData = JSON.parse(JSON.stringify(dataGridTableData));

            //TODO extract steps into separate files to clean up this component
            let steps: Step[] =
                [
                    {
                        name: 'livePerformancePerformanceDetails',
                        title: livePerformanceMaintenanceGridsViewData.fields.find(f => f.name.toString() === "livePerformancePerformanceDetails").data,
                        content: <LivePerformanceMaintenanceGeneralDataView
                            livePerformanceMaintenanceGeneralDataViewData={livePerformanceMaintenanceGeneralDataViewData}
                            usage={usage}
                            isReadOnly={isReadonly}
                            lookupValues={lookupValues}
                            updateLivePerformanceField={updateLivePerformanceField}
                            showModal={showModal}
                            hideModal={hideModal}
                            isNewLivePerformance={isNewLivePerformance}
                            activeTab={activeTab}
                            tabs={tabs}
                            resetMessageBanner={this.resetMessageBanner.bind(this)}
                            incrementTempID={incrementTempID}
                            editableFields={[]}
                            changesMade={changesMade}
                            setEditableFields={setEditableFields}
                            activeHeaderSection={tabs[activeTab].activeHeaderSection}
                            dataGridTableData={dataGridTableData}
                            livePerformanceMaintenanceGridsViewData={livePerformanceMaintenanceGridsViewData} 
                            addFileToUpload={addFileToUpload} 
                            cleanUploadFilesState={cleanUploadFilesState} 
                            containerDetailsWindowComponentData={containerDetailsWindowComponentData} 
                            destinations={destinations} 
                            distributions={distributions} 
                            droppedFiles={droppedFiles} 
                            isDropZone={isDropZone} 
                            selectedFileSystem={selectedFileSystem} 
                            setInDropZone={setInDropZone} 
                            setProgressUploadFileProccess={setProgressUploadFileProccess} 
                            sortColumn={sortColumn} 
                            storagePathItemData={storagePathItemData} 
                            attachedFiles={attachedFiles} 
                            refreshDirectory={refreshDirectory} 
                            paginationDetails={paginationDetails} 
                            updatePagination={updatePagination} 
                            addRepertoireAttachmentToState={addRepertoireAttachmentToState}
                            removeWorkAttachmentIfExists={removeWorkAttachmentIfExists}
                            removeLivePerformanceAttachmentFromState={removeLivePerformanceAttachmentFromState}
                            cleanDroppedFilesRepertoire={cleanDroppedFilesRepertoire}
                            setProgressUploadFileRepertoire={setProgressUploadFileRepertoire}
                            refreshWorkDetails={refreshWorkDetails}
                            dataSource={dataSource}   
                            getDataIngestionComponentData={getDataIngestionComponentData}   
                            addDroppedFileRepertoire={addDroppedFileRepertoire}
                            currentUserNameNumber={currentUserNameNumber}
                            disabledDate={disabledDate}
                            UsageAttachmentsDropped={UsageAttachmentsDropped}
                            spansTwoDates={this.state.spansTwoDates}
                            mainUsageEndDate={this.state.mainUsageEndDate}
                            onSpansTwoDatesChange={this.onSpansTwoDatesChange}
                            onMainUsageEndDateChange={this.onMainUsageEndDateChange}
                        />
                    },
                    {
                        name: 'livePerformanceSubmission',
                        title: livePerformanceMaintenanceGridsViewData.fields.find(f => f.name.toString() === "livePerformanceSubmission").data,
                        content: <div>
                            <div className="">
                                <h3>General</h3>
                                <LivePerformanceMaintenanceGeneralDataView
                                    livePerformanceMaintenanceGeneralDataViewData={livePerformanceMaintenanceGeneralDataViewData}
                                    usage={usage}
                                    isReadOnly={isReadonly}
                                    lookupValues={lookupValues}
                                    updateLivePerformanceField={updateLivePerformanceField}
                                    showModal={showModal}
                                    hideModal={hideModal}
                                    isNewLivePerformance={isNewLivePerformance}
                                    activeTab={activeTab}
                                    tabs={tabs}
                                    resetMessageBanner={this.resetMessageBanner.bind(this)}
                                    incrementTempID={incrementTempID}
                                    editableFields={[]}
                                    changesMade={changesMade}
                                    setEditableFields={setEditableFields}
                                    activeHeaderSection={tabs[activeTab].activeHeaderSection}
                                    dataGridTableData={readOnlyDataGridTableData}
                                    livePerformanceMaintenanceGridsViewData={livePerformanceMaintenanceGridsViewData}
                                    addFileToUpload={addFileToUpload}
                                    cleanUploadFilesState={cleanUploadFilesState}
                                    containerDetailsWindowComponentData={containerDetailsWindowComponentData}
                                    destinations={destinations}
                                    distributions={distributions}
                                    droppedFiles={droppedFiles}
                                    isDropZone={isDropZone}
                                    selectedFileSystem={selectedFileSystem}
                                    setInDropZone={setInDropZone}
                                    setProgressUploadFileProccess={setProgressUploadFileProccess}
                                    sortColumn={sortColumn}
                                    storagePathItemData={storagePathItemData}
                                    attachedFiles={attachedFiles}
                                    refreshDirectory={refreshDirectory}
                                    paginationDetails={paginationDetails}
                                    updatePagination={updatePagination} 
                                    addRepertoireAttachmentToState={addRepertoireAttachmentToState}
                                    removeWorkAttachmentIfExists={removeWorkAttachmentIfExists}
                                    removeLivePerformanceAttachmentFromState={removeLivePerformanceAttachmentFromState}
                                    cleanDroppedFilesRepertoire={cleanDroppedFilesRepertoire}
                                    setProgressUploadFileRepertoire={setProgressUploadFileRepertoire}
                                    refreshWorkDetails={refreshWorkDetails}
                                    dataSource={dataSource}
                                    getDataIngestionComponentData={getDataIngestionComponentData}
                                    currentUserNameNumber={currentUserNameNumber}
                                    disabledDate={disabledDate}
                                    client={client}
                                    spansTwoDates={this.state.spansTwoDates}
                                    mainUsageEndDate={this.state.mainUsageEndDate}
                                    onSpansTwoDatesChange={this.onSpansTwoDatesChange}
                                    onMainUsageEndDateChange={this.onMainUsageEndDateChange}
                                    addDroppedFileRepertoire={addDroppedFileRepertoire}
                                    UsageAttachmentsDropped={UsageAttachmentsDropped}
                                />
                            </div>
                        </div>
                    }
                ];
            
            if (dataSource !== DataSource.Intray) {
                steps = steps.filter(s => s.name === 'livePerformanceSubmission')
            }

            let zeroedStepsCurrent = stepsCurrent ?? 0;
            const {updatedScroll} = this.props;
            const {
                toolbarWidth
            } = this.state;
           return (
                <div className="">
                    {/* <div><span className="title">{title}</span></div> */}
                    <If condition={tabs[activeTab].versionNumber != null}>
                        <div><span>Version history number: {tabs[activeTab].versionNumber}</span></div>
                    </If>

                    <button type="button" className="toolbar-toggle" data-toggle="collapse" data-target="#toolbarContainer">
                        <MoreVertical16Regular className="icon" aria-hidden="true" />
                    </button>

                    <div id="toolbarContainer" className="WorkMaintenanceToolbar collapse" ref={this.toolbarParentRef}>
                        <LivePerformanceMaintenanceToolbar
                            changesMade={changesMade}
                            showYesNoPrompt={showYesNoPrompt}
                            showModal={showModal}
                            hideModal={hideModal}
                            resetMessageBanner={this.resetMessageBanner.bind(this)}
                            scroll={updatedScroll}
                            toolbarWidth={toolbarWidth}
                            toolbarData={livePerformanceMaintenanceToolbarData}
                            saveResultData={draftWorkMaintenanceSaveResultData}
                            usage={usage}
                            activeTab={activeTab}
                            tabs={tabs}
                            dataSource={dataSource}
                            saveChanges={this.saveAsDraftLivePerformance.bind(this)}
                            isReadonly={isReadonly}
                            undoDraftWorksChanges={this.undoChanges.bind(this)}
                            addNewDraftWorks={() => addNewDraftLivePerformance(lookupValues, true, livePerformanceMaintenanceGeneralDataViewData)}
                            isNew={isNewLivePerformance}
                            lookupValues={lookupValues}
                            copyExistingDraftLivePerformance={copyExistingDraftLivePerformance}
                            currentUser={currentUser}
                        />
                    </div>
                   {renderInfoToggle }
                    <LivePerformanceMultiStepForm
                       steps={steps}
                       isReadonly={isReadonly}
                       saveChanges={null}
                       confirmAndSubmit={this.confirmAndSubmit.bind(this)}
                       dataSource={dataSource}
                       current={zeroedStepsCurrent}
                       setCurrent={stepsSetCurrent}
                       usage={usage}
                       usageForValidation={this.prepareUsageForSave(usage, this.state.spansTwoDates ? this.state.mainUsageEndDate : undefined)}
                       resetMessageBanner={this.resetMessageBanner.bind(this)}
                       multiStepFormViewData={livePerformanceMaintenanceGeneralDataViewData}
                       tabs={tabs}
                       activeTab={activeTab}
                    />
                </div>
            );
        }
        return <div></div>;
    }
}
